import React, { useState } from "react";
import { TextEditor } from "../AutomatedCredit/CreditAnalysis/Components/TextEditor";
import { useForm } from "react-hook-form";
import { message } from "antd";
import { TBusinessInfo } from "../../custom-hooks/useExistingPrincipals";
import { errorHandler } from "../../helpers/errorHandler";
import { appInsights } from "../../config/appInsights";
import { postData } from "../../newApis/apiMethods";
import * as ajaxEndpoints from "../../api/ajax-endpoints";

interface IdeclineProps {
  dataRecord: {
    action: string;
    currentProspectivePrincipalData: TBusinessInfo;
  };
  onCloseModal: () => void;
}
const ProspectivePrincipalDeclineModal = (props: IdeclineProps) => {
  const [isLoadingDecline, setIsLoadingDecline] = useState(false);

  const { handleSubmit } = useForm({});
  const {
    dataRecord: { currentProspectivePrincipalData },
    onCloseModal,
  } = props;

  const [currentRichTextComments, setCurrentRichTextComments] = useState<
    string | null
  >(null);
  const handleChange = (data: string) => {
    setCurrentRichTextComments(data);
  };
  const handleDeclinePrincipal = async () => {
    setIsLoadingDecline(true);
    const reqBody = {
      reason: currentRichTextComments,
    };
    try {
      const response = await postData(
        `${ajaxEndpoints.PROSPECT_PRINCIPALS}/${currentProspectivePrincipalData?.id}/decline`,
        reqBody,
      );
      if (response?.status_code === 200) {
        message.success(response?.message);
        setTimeout(() => {
          onCloseModal();
        }, 2000);
      }
    } catch (error) {
      message.error(errorHandler(error));
      appInsights.trackException({
        exception: error as Error,
        properties: {
          fileName: "ProspectivePrincipalDeclineModal.tsx",
          errorMessage: errorHandler(error),
        },
      });
    } finally {
      setIsLoadingDecline(false);
    }
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body">
          <h2 className={`Modal__title mb-5 font-weight-bold`}>
            State reason for Declining this Principal
          </h2>
          <form onSubmit={handleSubmit(handleDeclinePrincipal)}>
            <div className="row"></div>
            <TextEditor
              onChange={handleChange}
              defaultValue={""}
              includeImageOptions={true}
            />
            <button
              className="btn advancly-btn"
              disabled={!currentRichTextComments}
            >
              {isLoadingDecline ? "Loading..." : "Decline Principal"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProspectivePrincipalDeclineModal;
